import { LegalPage } from "./LegalPage";
import { LEGAL } from "@/lib/legal";

export default function Cookies() {
  return (
    <LegalPage title="Política de cookies">
      <p>
        En <strong>{LEGAL.brand}</strong> usamos solo las cookies estrictamente necesarias para que la app funcione. No usamos cookies de publicidad ni de seguimiento de terceros.
      </p>

      <h2>¿Qué es una cookie?</h2>
      <p>
        Una cookie es un pequeño archivo que un sitio web guarda en tu navegador para reconocerte en visitas posteriores. Algunas son imprescindibles para que la web funcione, otras son opcionales.
      </p>

      <h2>Cookies que usamos</h2>
      <h3>Estrictamente necesarias (no requieren consentimiento)</h3>
      <ul>
        <li><strong>session_token</strong> — guarda tu sesión iniciada para que no tengas que iniciar sesión en cada página. Duración: 7 días. Origen: nuestra app.</li>
        <li><strong>__cf_bm</strong> — protección anti-bots de Cloudflare. Duración: 30 minutos. Origen: Cloudflare.</li>
      </ul>
      <h3>De terceros (al usar funciones específicas)</h3>
      <ul>
        <li><strong>Stripe</strong> — cuando entras al checkout, Stripe coloca sus propias cookies para prevenir fraude. Solo activas si decides suscribirte. Más información en la <a href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noopener noreferrer">política de cookies de Stripe</a>.</li>
        <li><strong>Google</strong> — al iniciar sesión con Google, Google gestiona sus propias cookies de autenticación.</li>
      </ul>

      <h2>Cookies que NO usamos</h2>
      <ul>
        <li>No usamos Google Analytics ni similar para perfilarte.</li>
        <li>No usamos cookies de publicidad ni de redes sociales.</li>
        <li>No vendemos datos de comportamiento a terceros.</li>
      </ul>

      <h2>Cómo gestionarlas</h2>
      <p>
        Puedes desactivar o borrar las cookies desde la configuración de tu navegador. Si deshabilitas las estrictamente necesarias, la app dejará de funcionar correctamente (no podrás iniciar sesión).
      </p>

      <h2>Contacto</h2>
      <p>
        Dudas sobre cookies: <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>.
      </p>
    </LegalPage>
  );
}
